import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { useHistory, useLocation } from 'react-router-dom';
import { AMPLITUDE_EVENTS } from '../../constants';
import * as Styles from './styles';
import { useTranslation } from 'react-i18next';
import {useApplicationStore, useIamUserProfileStore, useWorkflowsStore} from '../../Store/index';
import {AhaWidget } from './AhaWidget';
import {useStore} from '../Header/HeaderStore';
import { useAdoptEaseStore } from '../../Store/useAdoptEaseStore'
import { AhaPilotWidget } from './AhaPilotWidget';
import { useGetAhaPilotConfig, useUserProfile } from '../../hooks/queries';
import { useEffect, useState } from 'react';
import { ICustomField, UserInfo } from '../../types';
import moment from 'moment-timezone';
import { get } from 'lodash';

export function Tabs() {
  const history = useHistory();
  const location = useLocation();
  const { trackEvent } = useAnalytics();
  const {t} = useTranslation();
  const applications = useApplicationStore((state:any) => state.applications);
  const filteredApps = applications.filter((app: any) => app.isFavorite);
  const workflows = useWorkflowsStore((state:any) => state.workflows);
  const filteredWorkflows = workflows?.filter((workflow: any) => workflow.isFavorite);
  const setLastFocusedElement = useStore((state:any) => state.setLastFocusedElement);
  const {data: ahaPilotConfig} = useGetAhaPilotConfig();
  const [ ahaPilotActive, setAhaPiotActive ] = useState(false);
  const oktaUser = useUserProfile();
  const oktaUserInfo = (oktaUser.data || {}) as UserInfo;
  const iamUserInfo = useIamUserProfileStore((state:any) => state.iamUserInfo);

  const genNavigate =
    (tab: string, featureName: string = '') =>
    () => {
      featureName && tab === 'myUnify' ?  trackEvent(featureName, {
        'Tab': 'My Unify',
        'Favorited Apps': filteredApps.length,
        'Favorited Workflows': filteredWorkflows?.length,
        'Is Favorited': filteredApps.length || filteredWorkflows?.length ? true : false,
      }) :  trackEvent(featureName, {
        'Tab': tab});
      
      history.push(`/${tab}`);
    };

  const isActive = (tab: string) => {
    return location.pathname.includes(tab);
  };

  useEffect(() => {
    try{
      const customFields = ((ahaPilotConfig[0] || [[]] )[0] || { custom_fields: [] } ).custom_fields as ICustomField[];
      let pilotConfig = customFields?.reduce((acc, field) => { 
        return { ...acc, [field?.key]: field?.value } 
      }, {} as any);
      const now = new Date();
      const today = moment(`${now.getFullYear()}-${(now.getMonth() + 1)}-${now.getDate()}`, 'YYYY-MM-DD');
      const sDate = moment(pilotConfig?.unify_start_date, 'YYYY-MM-DD');
      const eDate = moment(pilotConfig?.unify_end_date, 'YYYY-MM-DD');
      const eId = get(oktaUserInfo, "userProfile.enterpriseId", "");
      const hasPilotRole = pilotConfig?.ca_role_test_picklist?.reduce(
        (acc: boolean, roleName: string) => { 
          return acc || iamUserInfo?.fullUser?.roles.find(
            (role:any) => role.roleName === roleName) !== undefined
        }, false);

      const entHasPilot = pilotConfig?.enterprises.length === 0 || pilotConfig?.enterprises?.indexOf(eId) >= 0;
      if(hasPilotRole && entHasPilot && sDate && eDate) {
        if(today.isSame(sDate) || today.isSame(eDate)) {
          setAhaPiotActive(true);
        }
        else if(today.isBefore(eDate) && today.isAfter(sDate)) {
          setAhaPiotActive(true);
        }
      }
    }
    catch(e) {
      console.log('ERROR in Aha Pilot Config', e);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ahaPilotConfig, iamUserInfo]);

  const enableAdopteaseApps = useAdoptEaseStore((state: any) => state.enableAdopteaseApps);

  return (
    <Styles.TabsContainer>
      <Styles.EmptyContainer></Styles.EmptyContainer>
      <div>
      <Styles.TabsHeader>
        <Styles.Tab
          onClick={genNavigate('myUnify', AMPLITUDE_EVENTS.TAB_SELECTED)}
          data-testid="myunify-tab"
          active={isActive('myUnify')}
          name={'myUnify'}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.currentTarget.click();
            }
          }}
        >
          {t('tabs.myUnify')}
        </Styles.Tab>
        <Styles.Tab
            onClick={genNavigate(
              'applications',
              AMPLITUDE_EVENTS.TAB_SELECTED
            )}
            data-testid="applications-tab"
            active={isActive('applications')}
            name={'applications'}
            id="unify-tab-apps"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                setLastFocusedElement(e.currentTarget);
                e.currentTarget.click();
              }
            }}>
            <div style={{ width: '15px', height: '15px', display: 'contents' }}>
              {t('tabs.applications')}
              {enableAdopteaseApps && !isActive('applications') &&
                <Styles.TabAdoptEaseRedDot data-testid="adopt-ease-icon">
                  <svg width="12" height="12">
                    <circle cx="6" cy="6" r="5" fill="red" />
                    <title> {t('adoptease.tryNow')}</title>
                  </svg>
                </Styles.TabAdoptEaseRedDot>}
            </div>
          </Styles.Tab>
          <Styles.Tab
          onClick={genNavigate('workflows', AMPLITUDE_EVENTS.TAB_SELECTED)}
          data-testid="workflows-tab"
          active={isActive('workflows')}
          name={'workflows'}
          id="unify-tab-wfs"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setLastFocusedElement( e.currentTarget);
              e.currentTarget.click();
            }
          }}
        >
          {t('tabs.workflows')}
        </Styles.Tab>
      </Styles.TabsHeader>
      </div>
      <Styles.AhaContainer> 
        <AhaWidget />
        { ahaPilotActive && <AhaPilotWidget /> }
      </Styles.AhaContainer>
    </Styles.TabsContainer>
  );
}
